import ClickEvent = JQuery.ClickEvent;

const classes = {
  activeTab: 'front-search__tab--active',
  activeBody: 'front-search__tab-body--active',
  tabBody: 'front-search__tab-body',
  tabBodyActive: 'front-search__tab-body--active',
};

/**
 * This class is responsible for the tabs containing the search forms
 * below the homepage banner. Also handles displaying the
 */
export class Banner {

  /**
   * The list of tabs.
   */
  private $tabs: JQuery<HTMLDivElement>;

  /**
   * The body of the table containing the form.
   */
  private $tabBodies: JQuery<HTMLDivElement>;

  /**
   * List of slides.
   */
  private $slides: JQuery<HTMLDivElement>;

  constructor() {
    if ($('.js-banner').length === 0) {
      return;
    }

    this.$tabs = $('.front-search__tab');
    this.$tabBodies = $('.front-search__tab-body');
    this.$slides = $('.banner__item');

    // Event listeners
    this.$tabs.on('click', (e: ClickEvent) => this.switchTab(e));
  }

  /**
   * Toggle the tabs while on desktop view also starts playing
   * the movie when switching to a movie tab.
   */
  public switchTab(e: ClickEvent): void {
    const $currentTab = $(e.currentTarget);
    const target = $currentTab.data('tab');
    const index = $currentTab.data('slide');

    // Switch active tab
    this.$tabs.removeClass(classes.activeTab);
    $currentTab.addClass(classes.activeTab);

    // Switch tab body
    this.$tabBodies.removeClass(classes.activeBody);

    $('.js-front-search__tab-' + target)
      .find('.front-search__tab-body')
      .addClass(classes.activeBody);

    // Switch slides.
    const $current = this.$slides.eq(index);

    $current.addClass('active');
    this.$slides.not($current).removeClass('active');

    $('.js-header-video').trigger('play');
  }

}
